/* global window */

import { Field } from 'formik';
import { useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  Form,
  trimFormValues,
  InputField,
  SubmitButton,
  FormErrors
} from 'common/components/forms';
import { getProfileHref } from 'common/helpers/routerHelper';
import { login } from 'redux/customer/actions';
import { useLocalization } from 'redux/localization/utils/hooks';

import SocialLogin from './components/SocialLogin';
import { validateLogin } from './validators';

/* TODO Consildate with checkout login */

const LoginForm = (props) => {
  const { redirectTo } = props;

  const [showMessage, setShowMessage] = useState(null);
  const dispatch = useDispatch();
  const { t } = useLocalization();

  const handleSubmit = (values, formik) => {
    const data = transformData(values);
    const onError = () => {
      formik.setSubmitting(false);
      setShowMessage('Error');
    };
    const onSuccess = () => {
      formik.setSubmitting(false);
      window.location.href = redirectTo;
    };
    dispatch(login(data.email, data.password, onSuccess, onError));
  };

  const handleSuccess = () => {
    window.location.href = redirectTo;
  };

  return (
    <>
      <Form
        validate={(values) => validate(values, t)}
        initialValues={getInitialValues()}
        onSubmit={handleSubmit}
        className="c7-form--login"
      >
        {showMessage === 'Error' ? (
          <FormErrors
            error={t('general.errorMessages.incorrectEmailPassword')}
          />
        ) : (
          <FormErrors />
        )}
        <Field
          label={t('general.common.email')}
          component={InputField}
          required
          type="text"
          inputMode="email"
          name="email"
          autoComplete="email"
          autoFocus
        />
        <Field
          label={t('customerAccount.password.password')}
          component={InputField}
          required
          type="password"
          name="password"
          autoComplete="current-password"
        />

        <div className="c7-form__buttons c7-form__buttons--wide">
          <SubmitButton>{t('customerAccount.login.log in')}</SubmitButton>
        </div>
      </Form>
      <div className="c7-account-login__password-options">
        <p>
          <a href={getProfileHref('/forgot-password')} className="c7-link">
            {t('customerAccount.password.forgetPassword')}
          </a>
        </p>
      </div>

      <SocialLogin onSuccess={handleSuccess} />
    </>
  );
};

const transformData = (formValues) => {
  const values = trimFormValues(formValues);
  const data = {
    email: values.email.toLowerCase(),
    password: values.password
  };
  return data;
};

const validate = (values, t) => {
  const data = transformData(values);
  const errors = validateLogin(data, t);
  return errors;
};

const getInitialValues = () => ({ email: '', password: '' });

export default LoginForm;
